
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface CompanyLogoProps {
  logoUrl: string;
  companyName: string;
  onClearLogo: () => void;
}

export const CompanyLogo = ({ logoUrl, companyName, onClearLogo }: CompanyLogoProps) => {
  if (!logoUrl) return null;

  return (
    <div className="flex items-center justify-between">
      <div className="mb-4 flex items-center">
        <div className="h-16 w-16 bg-digger-light-gray rounded-md flex items-center justify-center overflow-hidden mr-4">
          <img 
            src={logoUrl} 
            alt={`${companyName} logo`} 
            className="h-14 w-14 object-contain" 
            onError={(e) => {
              // If the image fails to load, show a placeholder
              (e.target as HTMLImageElement).src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWJ1aWxkaW5nLTIiPjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIyMCIgeD0iNCIgeT0iMiIgcng9IjIiIHJ5PSIyIi8+PHBhdGggZD0iTTkgMjJ2LTRoNnY0Ii8+PHBhdGggZD0iTTggNmguMDEiLz48cGF0aCBkPSJNMTYgNmguMDEiLz48cGF0aCBkPSJNMTIgNmguMDEiLz48cGF0aCBkPSJNOCAxMGguMDEiLz48cGF0aCBkPSJNMTYgMTBoLjAxIi8+PHBhdGggZD0iTTEyIDEwaC4wMSIvPjxwYXRoIGQ9Ik04IDE0aC4wMSIvPjxwYXRoIGQ9Ik0xNiAxNGguMDEiLz48cGF0aCBkPSJNMTIgMTRoLjAxIi8+PC9zdmc+";
            }}
          />
        </div>
        <div>
          <p className="text-sm font-medium">Company Logo</p>
          <p className="text-xs text-gray-500">Logo automatically retrieved</p>
        </div>
      </div>
      <Button 
        type="button" 
        variant="outline" 
        size="sm" 
        onClick={onClearLogo}
        className="h-8"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
